import mitt from 'mitt';
import { onUnmounted } from 'vue';

// Create a global event bus
const eventBus = mitt();

export function useEventBus() {
  const emitEvent = (eventName, payload) => {
    eventBus.emit(eventName, payload);
  };

  const onEvent = (eventName, callback) => {
    eventBus.on(eventName, callback);

    // Cleanup when component unmounts
    onUnmounted(() => {
      console.log(`Cleaning up event listener for ${eventName}`);
      eventBus.off(eventName, callback);
    });
  };

  return {
    emitEvent,
    onEvent,
  };
}
